import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../../../shared/models/user.model';

@Pipe({
  name: 'searchAdminUser'
})
export class SearchAdminUserPipe implements PipeTransform {

  transform(users: User[], query: string): User[] {
    if (!query) {
      return users;
    }
    return users.filter(user => user.lastName?.includes(query) || user.firstName?.includes(query) || user.email?.includes(query));
  }

}
